/**
 * 已知无效/占位 GPS（不可用于指挥台落点与视野恢复）
 * 37.751,-97.822：MaxMind/网络定位「未知」默认点（美国堪萨斯）
 */
export const BOGUS_GPS_POINTS = [
  // 半径约 2km：覆盖 Chrome 返回的 37.751002,-97.822216 等微调值
  { lat: 37.751, lng: -97.822, label: 'maxmind_default_us', eps: 0.02 },
  { lat: 0, lng: 0, label: 'null_island', eps: 0.05 }
];

/** 龙泉默认指挥视野（WGS84） */
export const SAFE_COMMAND_CENTER = [119.13643, 28.07741];

const DEFAULT_EPS = 0.0005;

export function isBogusGpsCoordinate(lat, lng) {
  const la = Number(lat);
  const ln = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(ln)) return true;
  if (Math.abs(la) > 90 || Math.abs(ln) > 180) return true;
  return BOGUS_GPS_POINTS.some((p) => {
    const eps = Number.isFinite(p.eps) ? p.eps : DEFAULT_EPS;
    return Math.abs(la - p.lat) < eps && Math.abs(ln - p.lng) < eps;
  });
}

/**
 * 指挥台可用落点：非伪定位，且大致在中国搜救业务范围内
 * （避免 Chrome 网络定位把视野拉到美国/欧洲等）
 */
export function isPlausibleCommandCoordinate(lat, lng) {
  if (isBogusGpsCoordinate(lat, lng)) return false;
  const la = Number(lat);
  const ln = Number(lng);
  // 中国大陆+近海缓冲（含海南、东北）
  return ln >= 73 && ln <= 135 && la >= 15 && la <= 54;
}

/** 清除伪定位相关本地存档（指挥员定位 + 地图中心） */
export function purgeBogusMapLocalState(
  storage = typeof localStorage !== 'undefined' ? localStorage : null
) {
  if (!storage) return { commander: false, mapState: false };
  let commander = false;
  let mapState = false;
  try {
    const raw = storage.getItem('dashboard_last_commander_location');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (!isPlausibleCommandCoordinate(parsed?.lat, parsed?.lng)) {
        storage.removeItem('dashboard_last_commander_location');
        commander = true;
        console.warn('已清除不可用指挥员存档', parsed?.lat, parsed?.lng);
      }
    }
  } catch (_) {
    try {
      storage.removeItem('dashboard_last_commander_location');
      commander = true;
    } catch (__) {
      /* ignore */
    }
  }
  try {
    const raw = storage.getItem('map_state');
    if (raw) {
      const all = JSON.parse(raw);
      const dash = all?.dashboard;
      if (dash?.center && Array.isArray(dash.center) && dash.center.length >= 2) {
        const lng = Number(dash.center[0]);
        const lat = Number(dash.center[1]);
        if (!isPlausibleCommandCoordinate(lat, lng)) {
          delete all.dashboard;
          storage.setItem('map_state', JSON.stringify(all));
          mapState = true;
          console.warn('已清除伪定位地图存档', lng, lat);
        }
      }
    }
  } catch (_) {
    /* ignore */
  }
  try {
    // 设备上次定位：仅清除伪/境外，不清有效记录（刷新后还要飞回去）
    const raw = storage.getItem('dashboard_last_device_location');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (!isPlausibleCommandCoordinate(parsed?.lat, parsed?.lng)) {
        storage.removeItem('dashboard_last_device_location');
        console.warn('已清除伪定位设备存档', parsed?.lat, parsed?.lng);
      }
    }
  } catch (_) {
    /* ignore */
  }
  try {
    if (typeof sessionStorage !== 'undefined') {
      const raw = sessionStorage.getItem('dashboard_last_device_location');
      if (raw) {
        const parsed = JSON.parse(raw);
        if (!isPlausibleCommandCoordinate(parsed?.lat, parsed?.lng)) {
          sessionStorage.removeItem('dashboard_last_device_location');
        }
      }
    }
  } catch (_) {
    /* ignore */
  }
  return { commander, mapState };
}

/** @deprecated 使用 purgeBogusMapLocalState */
export function purgeBogusCommanderLocationIfNeeded(storage) {
  return purgeBogusMapLocalState(storage).commander;
}
